module.exports = __webpack_public_path__ + "img/1537287920.99a78c27.jpg";